import { createSlice } from '@reduxjs/toolkit'
import { getConfiguration } from 'api/configuration'
import { getSupportingDocumentsConfig } from 'api/supportingDocuments'
const initialState = {
  loading: true,
  uploadLoading: false,
  loadingText: '',
  error: "",
  config: {}
}

export const configurationReducer = createSlice({
  name: 'configurationReducer',
  initialState,
  reducers: {
    clearConfiguration: (state) => {
      state.config = {}
    },
    setConfigLoading: (state, action) => {
      state.loading = action.payload
      if (action.payload === false) {
        state.loadingText = ''
      }
    },
    setUploadLoading: (state, action) => {
      state.uploadLoading = action.payload
      if (action.payload === false) {
        state.loadingText = ''
      }
    },
    setConfigLoadingText: (state, action) => {
      state.loadingText = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfiguration.pending, state => {
        state.loading = true
      })
      .addCase(getConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload
        state.error = "success"
      })
      .addCase(getConfiguration.rejected, (state) => {
        state.loading = false
        state.error = "rejected"
      })
    builder
      .addCase(getSupportingDocumentsConfig.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getSupportingDocumentsConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
        state.error = "success";
      })
      .addCase(getSupportingDocumentsConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = "rejected";
      })
  }
})
export const {
  clearConfiguration,
  setConfigLoading,
  setUploadLoading,
  setConfigLoadingText
} = configurationReducer.actions
export default configurationReducer.reducer